import {IUrlObject} from "../resources/url.resource";

export interface IConfig {
    readonly auth0UserClientId: string;
    readonly auth0Host: string;
    readonly firebaseRoot: string;
    readonly logEntriesBrowserAppToken: string;
    readonly segmentWriteKey: string;
    readonly secondsUntilTokenRefresh: number;
    readonly secondsOkToUseTokenBeforeExpiry: number;
    readonly appUrls: {[type: string]: string};
    readonly joyServiceConfig: IUrlObject;
    readonly joyMediaServiceConfig: IUrlObject;
    readonly joyRegistriesServiceConfig: IUrlObject;
    readonly joyWebsiteConfig: IUrlObject;
    readonly joyMarketingWebsiteConfig: IUrlObject;
    readonly joyBlissGatewayConfig: IUrlObject;
    readonly joySupportWebsiteConfig: IUrlObject;
    readonly joyRedirectConfig: IUrlObject;
}

/**
 * secondsUntilTokenRefresh: 60,
 secondsOkToUseTokenBeforeExpiry: 10,

 */
class Config implements IConfig {
    constructor(private env: any) {
        if (Object.keys(this.env).length === 0) {
            this.env = process.env;
        }
    }

    get auth0UserClientId() {return this.env.JOY_CONFIG_AUTH0_CLIENTID || "EsiknQLsU7Sy4Baqv7cZYM1xzifHQX3r";}
    get auth0Host() {return "withjoy.auth0.com";}
    get firebaseRoot() {return this.env.JOY_CONFIG_ROOT_FIREBASE || "https://joyauth.firebaseio.com";}
    get logEntriesBrowserAppToken() {return this.env.JOY_CONFIG_LE_TOKEN_BROWSER || null;}
    get segmentWriteKey() {return this.env.JOY_CONFIG_SEGMENT_WRITE_KEY || "2xZJ98aly8fmfFDB9msDQlXsyVGVpUby";}
    get secondsUntilTokenRefresh() {return 60;}
    get secondsOkToUseTokenBeforeExpiry() {return 10;}

    get joyServiceConfig(): IUrlObject {
        return {
            protocol: this.env.JOY_CONFIG_SERVICE_PROTOCOL || "https",
            hostname: this.env.JOY_CONFIG_SERVICE_HOSTNAME || "rehearsal-api.withjoy.com",
            port: this.env.JOY_CONFIG_SERVICE_PORT || 443,
            routePrefix: this.env.JOY_CONFIG_SERVICE_ROUTE_PREFIX
        };
    }

    get joyMediaServiceConfig(): IUrlObject {
        return {
            protocol: this.env.JOY_CONFIG_MEDIA_SERVICE_PROTOCOL || "https",
            hostname: this.env.JOY_CONFIG_MEDIA_SERVICE_HOSTNAME || "rehearsal-api.withjoy.com",
            port: this.env.JOY_CONFIG_MEDIA_SERVICE_PORT || 443,
            routePrefix: this.env.JOY_CONFIG_MEDIA_ROUTE_PREFIX
        };
    }

    get joyRegistriesServiceConfig(): IUrlObject {
        return {
            protocol: this.env.JOY_CONFIG_REGISTRIES_SERVICE_PROTOCOL || "https",
            hostname: this.env.JOY_CONFIG_REGISTRIES_SERVICE_HOSTNAME || "ceremony-registries.withjoy.com",
            port: this.env.JOY_CONFIG_REGISTRIES_SERVICE_PORT || 443,
            routePrefix: this.env.JOY_CONFIG_REGISTRIES_ROUTE_PREFIX
        };
    }
    
    get joyWebsiteConfig(): IUrlObject {
        return {
            protocol: this.env.JOY_CONFIG_WEBSITE_PROTOCOL || "https",
            hostname: this.env.JOY_CONFIG_WEBSITE_HOSTNAME || "rehearsal.withjoy.com",
            port: this.env.JOY_CONFIG_WEBSITE_PORT || 443
        }
    }
    
    get joyMarketingWebsiteConfig(): IUrlObject {
        return {
            protocol: this.env.JOY_CONFIG_MARKETING_WEBSITE_PROTOCOL || "https",
            hostname: this.env.JOY_CONFIG_MARKETING_WEBSITE_HOSTNAME || "rehearsal.withjoy.com",
            port: this.env.JOY_CONFIG_MARKETING_WEBSITE_POST || 443
        }
    }


    get joyBlissGatewayConfig(): IUrlObject {
        return {
            protocol: this.env.JOY_CONFIG_BLISS_GATEWAY_PROTOCOL || "https",
            hostname: this.env.JOY_CONFIG_BLISS_GATEWAY_HOSTNAME || "bliss-gateway.withjoy.com",
            port: this.env.JOY_CONFIG_BLISS_GATEWAY_PORT || 443
        }
    }
    
    get joySupportWebsiteConfig(): IUrlObject {
        return {
            protocol: this.env.JOY_CONFIG_MARKETING_WEBSITE_PROTOCOL || "https",
            hostname: this.env.JOY_CONFIG_MARKETING_WEBSITE_HOSTNAME || "help.withjoy.com",
            port: this.env.JOY_CONFIG_MARKETING_WEBSITE_POST || 443
        }
    }

    get appUrls(): {[type: string]: string} {
        return {
            ios: "https://itunes.apple.com/app/joy-wedding-app-website/id994411720?mt=8",
            android: "https://play.google.com/store/apps/details?id=com.withjoy.joy"
        }
    }

    get joyRedirectConfig(): IUrlObject {
        return {
            protocol: this.env.JOY_CONFIG_REDIRECT_PROTOCOL || "https",
            hostname: this.env.JOY_CONFIG_REDIRECT_HOSTNAME || "rehearsal-redirect.withjoy.com",
            port: this.env.JOY_CONFIG_REDIRECT_PORT || 443,
            routePrefix: this.env.JOY_CONFIG_REDIRECT_ROUTE_PREFIX
        }
    }

}

const getEnvOverrides = (g) => {
    if (g.joyEnv) {
        return g.joyEnv
    }
    return {};
};

export const globalObj = <any>((typeof window !== "undefined" && window) || {});
export const config: IConfig = new Config(getEnvOverrides(globalObj));
export const getFullConfig = (callback) => {
    setImmediate(callback.bind(null, null, config));
};

